import { EditProjectContextProps } from "../../EditProjectContext";
import { getSpdrShipFrequency } from "./GetSpdrShipFrequency";

export async function setAllShipFrequencies({
  project,
  setProject,
}: EditProjectContextProps) {
  // eslint-disable-next-line no-restricted-syntax
  for await (const ltlPipeline of project?.ltlPipelines || []) {
    if (ltlPipeline.SupplierShipFrequency) {
      // eslint-disable-next-line no-continue
      continue;
    }

    ltlPipeline.SupplierShipFrequency = await getSpdrShipFrequency(
      ltlPipeline?.SpdrId
    );
  }
  setProject(project);
}
